import PropTypes from "prop-types";
import Link from "next/link";
import { SUGGESTIONS } from "../../../../constants/common/common";
import CustomImage from "../../../atoms/customImage";
import Typography from "../../../atoms/typography";

/**
 * Suggestions component renders a list of search suggestions or a no-results message
 * if no suggestions are available.
 *
 * @param {Object} props - Component properties.
 * @param {Array} props.searchSuggestion - List of search suggestions, where each suggestion contains a target URL and category name.
 * @param {Function} props.onSearchTrackEvent - Function to track search events.
 * @param {Function} props.onNavigate - Function to handle navigation (closes drawer and shows skeleton).
 *
 * @returns {JSX.Element} The rendered Suggestions component.
 */
const Suggestions = ({ searchSuggestion, onSearchTrackEvent = () => {}, onNavigate = () => {} }) => {
  return (
    <div className="flex w-full flex-col border-b-2 border-white p-16">
      {/* Title indicating suggestions */}
      <Typography variant="p" Tag="p" classes="flex w-full font-400 text-14 text-grey-400">
        {SUGGESTIONS}
      </Typography>

      <ul className="mt-8 flex w-full flex-col">
        {searchSuggestion.map((item) => (
          <li className="flex w-full border-t-1" key={item?.targetUrl}>
            <Link
              href={`/${item?.targetUrl}`}
              className="flex w-full gap-8 py-16 text-14 font-400 text-fnp-500"
              onClick={() => {
                onSearchTrackEvent(item?.categoryName, item);
                onNavigate();
              }}
            >
              <CustomImage
                src="/icons/search-normal.svg"
                width={20}
                height={20}
                isPriority={false}
                sizes="10vw"
                alt="search icons"
              />
              <Typography
                Tag="p"
                classes="block text-14 font-normal text-fnp-500 w-[calc(100%-28px)] overflow-hidden text-ellipsis whitespace-nowrap"
              >
                {item?.categoryName}
              </Typography>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
};
Suggestions.propTypes = {
  searchSuggestion: PropTypes.arrayOf(
    PropTypes.shape({
      targetUrl: PropTypes.string.isRequired,
      categoryName: PropTypes.string.isRequired,
    }),
  ).isRequired,
  onSearchTrackEvent: PropTypes.func,
  onNavigate: PropTypes.func,
};
export default Suggestions;
